import React from "react";
import {
  Navbar,
  NavbarBrand,
  NavItem,
  Nav,
  UncontrolledTooltip,
} from "reactstrap";
import { MdMenu } from "react-icons/md";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { allRoutes } from "../../../_constants/routes.constants";
import { IoMdBook } from "react-icons/io";
import AppManual from "./Manual/ManageManual";

class CustomNavBar extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false,
      manualOpen: false,
    };
  }
  handManual = () => {
    this.setState({ manualOpen: !this.state.manualOpen });
  };

  closeHandManual = () => {
    this.setState({
      manualOpen: false,
    });
  };
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }
  render() {
    const { toggleFullWidth, role } = this.props;

    const currentRoute = allRoutes.filter(
      route => route.path === this.props.location.pathname
    );
    if (role === "ROLE_VLA_INSTRUCTOR" || role === "ROLE_VLA_ADMIN") {
      return (
        <div>
          <Navbar className="horizontalMenu">
            <NavbarBrand className="pointer" onClick={toggleFullWidth}>
              <span className="icon">
                <MdMenu color="#FFF" size={25} />
              </span>
              {currentRoute && currentRoute.length && currentRoute[0].title}
            </NavbarBrand>
            <Nav>
              <NavItem className="btn">
                <span style={{ cursor: "pointer" }} onClick={this.handManual}>
                  <IoMdBook color="#FFF" size={25} id="manualTip" />{" "}
                  <UncontrolledTooltip placement="bottom" target="manualTip">
                    Manual
                  </UncontrolledTooltip>
                </span>
              </NavItem>
            </Nav>
          </Navbar>
          <AppManual
            visible={this.state.manualOpen}
            closeHandManual={this.closeHandManual}
            role={role}
          />
        </div>
      );
    } else {
      return (
        <div>
          <Navbar className="horizontalMenu">
            <NavbarBrand className="pointer" onClick={toggleFullWidth}>
              <span className="icon">
                <MdMenu color="#FFF" size={25} />
              </span>
            </NavbarBrand>
          </Navbar>
        </div>
      );
    }
  }
}

Navbar.propTypes = {
  light: PropTypes.bool,
  dark: PropTypes.bool,
  fixed: PropTypes.string,
  color: PropTypes.string,
  role: PropTypes.string,
  expand: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
};

NavbarBrand.propTypes = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
};

const CNavBar = withRouter(CustomNavBar);

export { CNavBar };
